import * as React from "react";
const IconGrace = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.9863 2.4065C15.0327 2.13677 14.0264 1.99243 12.9863 1.99243C11.9463 1.99243 10.94 2.13677 9.98633 2.4065"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M17.9863 15.9924V21.9924"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.9863 18.9924L14.9863 18.9924"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4863 13.9924C14.4863 14.8209 13.8148 15.4924 12.9863 15.4924C12.1579 15.4924 11.4863 14.8209 11.4863 13.9924C11.4863 13.164 12.1579 12.4924 12.9863 12.4924C13.8148 12.4924 14.4863 13.164 14.4863 13.9924Z"
      stroke="#1C1C2C"
      strokeWidth={1.5}
    />
    <path
      d="M21.1127 15.9924C21.3556 15.202 21.4863 14.3625 21.4863 13.4924C21.4863 8.79801 17.6807 4.99243 12.9863 4.99243C8.29191 4.99243 4.48633 8.79801 4.48633 13.4924C4.48633 18.1869 8.29191 21.9924 12.9863 21.9924C13.6752 21.9924 14.3449 21.9105 14.9863 21.7558"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M12.9863 11.9924V8.99243"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconGrace;
